import { useLocation } from 'react-router-dom';

export enum AvailableQueryParamKeys {
  CV_PRESELECTED_DATETIME_QUERY_PARAM = 'selectedVideoApptDateTime',
  CV_STORE_ID = 'storeId',
  CV_IFRAME_MODE = 'iframeMode',
  CV_BOOKED_BY_TEAM_MEMBER_ID = 'bookedByTeamMemberId',
  CV_REDIRECT_SOURCE = 'source',
}

export const useGetQueryParams = (queryParamKey: AvailableQueryParamKeys): string | null => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const queryParam = queryParams.get(queryParamKey);
  return queryParam;
};
